<template>
    <el-dialog
        :title="dialogType === 'add' ? '新增' : '修改'"
        width="75%"
        @close="closeAddDialog"
        :close-on-click-modal="false"
        class="leader-dialog"
        :visible.sync="dialogFormVisible"
    >
        <el-form
            ref="addComForm"
            :rules="addComRules"
            class="leader-style-form"
            :model="addComForm"
        >
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="父采集点名称" label-width="150px">
                        <el-input
                            ref="p_point_ref"
                            maxlength="20"
                            v-model="addComForm.p_point_name"
                            @focus="changePPointID"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="采集点名称"
                        prop="point_name"
                        label-width="150px"
                    >
                        <el-input
                            maxlength="100"
                            v-model="addComForm.point_name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="安装位置" label-width="150px">
                        <el-input
                            maxlength="50"
                            v-model="addComForm.position"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                    <el-form-item label="采集单元" prop="doc_id">
                        <el-select v-model="addComForm.doc_id">
                            <el-option
                                v-for="item in unitList"
                                :key="item.doc_id"
                                :label="item.doc_name"
                                :value="item.doc_id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>-->
                <el-col :span="12">
                    <el-form-item label="户号" label-width="150px">
                        <el-select
                            v-model="addComForm.elec_customer_account_id"
                        >
                            <el-option
                                v-for="item in numberList"
                                :key="item.elec_customer_account_id"
                                :label="item.account_name"
                                :value="item.elec_customer_account_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="采集频率" label-width="150px">
                        <el-select v-model="addComForm.collect_frequency">
                            <el-option
                                v-for="item in frequencyList"
                                :key="item.code_value"
                                :label="item.code_name"
                                :value="item.code_value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="采集点类型"
                        prop="point_class_id"
                        label-width="150px"
                    >
                        <el-select
                            v-model="addComForm.point_class_id"
                            @change="changeClassId"
                        >
                            <el-option
                                v-for="item in point_type_list"
                                :key="item.point_class_id"
                                :label="item.class_name"
                                :value="item.point_class_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="用途"
                        prop="point_type"
                        label-width="150px"
                    >
                        <el-select v-model="addComForm.point_type">
                            <el-option
                                v-for="item in point_types"
                                :key="item.code_value"
                                :label="item.code_name"
                                :value="item.code_value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="addComForm.point_type == 10">
                    <el-form-item
                        label="光伏类型"
                        prop="pv_type"
                        label-width="150px"
                    >
                        <el-select v-model="addComForm.pv_type">
                            <el-option
                                v-for="item in pv_types"
                                :key="item.code_value"
                                :label="item.code_name"
                                :value="item.code_value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="反向映射到采集点"
                        prop="f_to_point_id"
                        label-width="150px"
                    >
                        <el-select v-model="addComForm.f_to_point_id" filterable>
                            <el-option
                                v-for="item in point_f"
                                :key="item.point_id"
                                :label="item.point_name"
                                :value="item.point_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="addComForm.point_class_id == 1689906136465186816">
                    <el-form-item
                        label="型号"
                        prop="model"
                        label-width="150px"
                    >
                        <el-input
                            maxlength="100"
                            v-model="addComForm.model"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="addComForm.point_class_id == 1689906136465186816">
                    <el-form-item
                        label="交流功率"
                        prop="rated_p"
                        label-width="150px"
                    >
                        <el-input
                            maxlength="50"
                            v-model="addComForm.rated_p"
                            autocomplete="off"
                            class="line_height"
                            type="number"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="addComForm.point_class_id == 1689906136465186816">
                    <el-form-item
                        label="所属并网柜"
                        prop="bwg_point_id"
                        label-width="150px"
                    >
                        <el-select v-model="addComForm.bwg_point_id" filterable>
                            <el-option
                                v-for="item in point_bwg"
                                :key="item.point_id"
                                :label="item.point_name"
                                :value="item.point_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="addComForm.point_class_id == 1658026900632879104 || addComForm.point_class_id == '020'
|| addComForm.point_class_id == '021' || addComForm.point_class_id == '022' || addComForm.point_class_id == '023'">
                    <el-form-item
                        label="额定容量"
                        prop="capacity"
                        label-width="150px"
                    >
                        <el-input
                            maxlength="50"
                            v-model="addComForm.capacity"
                            type="number"
                        ></el-input>
                    </el-form-item>
                </el-col>


                <!--储能柜-->
                <el-col :span="12" v-if="addComForm.point_class_id == '020'">
                    <el-form-item
                        label="关联的电表id"
                        prop="relation_point_id"
                        label-width="150px"
                    >
                        <el-select v-model="addComForm.relation_point_id" filterable>
                            <el-option
                                v-for="item in pointList1111"
                                :key="item.point_id"
                                :label="item.point_name"
                                :value="item.point_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12" v-if="addComForm.point_class_id == '021'">
                    <el-form-item
                        label="所属储能柜"
                        prop="bwg_point_id"
                        label-width="150px"
                    >
                        <el-select v-model="addComForm.bwg_point_id" filterable>
                            <el-option
                                v-for="item in point_bwg"
                                :key="item.point_id"
                                :label="item.point_name"
                                :value="item.point_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>


                <el-col :span="12" v-if="addComForm.point_class_id == '022'">
                    <el-form-item
                        label="所属pcs"
                        prop="bwg_point_id"
                        label-width="150px"
                    >
                        <el-select v-model="addComForm.bwg_point_id" filterable>
                            <el-option
                                v-for="item in point_bwg"
                                :key="item.point_id"
                                :label="item.point_name"
                                :value="item.point_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>


                <el-col :span="12" v-if="addComForm.point_class_id == '023'">
                    <el-form-item
                        label="所属电池簇"
                        prop="bwg_point_id"
                        label-width="150px"
                    >
                        <el-select v-model="addComForm.bwg_point_id" filterable>
                            <el-option
                                v-for="item in point_bwg"
                                :key="item.point_id"
                                :label="item.point_name"
                                :value="item.point_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>


                <!-- <el-col :span="12" v-if="addComForm.point_class_id == '001'">
                    <el-form-item
                        label="电量变比"
                        prop="jc_rate"
                        label-width="150px"
                    >
                        <el-input
                            maxlength="50"
                            v-model="addComForm.jc_rate"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :span="12" class="tip_col"
                >电量统计标识：w_active
                    &nbsp;&nbsp;&nbsp;&nbsp;水量统计标识：t_Q
                </el-col
                >
            </el-row>
            <el-row>
                <!-- 开关099 红外095 门磁096 水侵097 烟感098 -->
                <template
                    v-if="
                        addComForm.point_class_id == '099' ||
                            addComForm.point_class_id == '095' ||
                            addComForm.point_class_id == '096' ||
                            addComForm.point_class_id == '097' ||
                            addComForm.point_class_id == '098'
                    "
                >
                    <el-table
                        border
                        style="width: 100%"
                        :data="addComForm.switchList"
                        class="leader-style-table"
                    >
                        <el-table-column label="数据项" property="column_name">
                            <template slot-scope="scope">
                                <el-form-item
                                    :prop="
                                        'switchList.' +
                                            scope.$index +
                                            `.column_name`
                                    "
                                    :rules="[
                                        {
                                            required: true,
                                            message: '请输入数据项',
                                            trigger: 'blur'
                                        }
                                    ]"
                                >
                                    <el-input
                                        v-model="scope.row.column_name"
                                        maxlength="60"
                                    ></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="1" property="switch1_name">
                            <template slot-scope="scope">
                                <el-form-item
                                    :prop="
                                        'switchList.' +
                                            scope.$index +
                                            `.switch1_name`
                                    "
                                    :rules="[
                                        {
                                            required: true,
                                            message: '请输入名称',
                                            trigger: 'blur'
                                        }
                                    ]"
                                >
                                    <el-input
                                        v-model="scope.row.switch1_name"
                                        maxlength="20"
                                    ></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="0" property="switch0_name">
                            <template slot-scope="scope">
                                <el-form-item
                                    :prop="
                                        'switchList.' +
                                            scope.$index +
                                            `.switch0_name`
                                    "
                                    :rules="[
                                        {
                                            required: true,
                                            message: '请输入名称',
                                            trigger: 'blur'
                                        }
                                    ]"
                                >
                                    <el-input
                                        v-model="scope.row.switch0_name"
                                        maxlength="20"
                                    ></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <!-- 保护动作005 -->
                <template v-else-if="addComForm.point_class_id == '005'">
                    <div style="text-align: right; margin-bottom: 20px">
                        <el-button
                            class="leader-common-button"
                            @click="addProtect()"
                        >增加
                        </el-button
                        >
                    </div>

                    <el-table
                        border
                        style="width: 100%"
                        :data="addComForm.protectList"
                        class="leader-style-table"
                    >
                        <el-table-column label="数据项" property="column_name">
                            <template slot-scope="scope">
                                <el-form-item
                                    :prop="
                                        'protectList.' +
                                            scope.$index +
                                            `.column_name`
                                    "
                                    :rules="[
                                        {
                                            required: true,
                                            message: '请输入数据项',
                                            trigger: 'blur'
                                        }
                                    ]"
                                >
                                    <el-input
                                        v-model="scope.row.column_name"
                                        maxlength="60"
                                    ></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="保护动作" property="protect">
                            <template slot-scope="scope">
                                <el-form-item
                                    :prop="
                                        'protectList.' +
                                            scope.$index +
                                            `.protect`
                                    "
                                    :rules="[
                                        {
                                            required: true,
                                            message: '请输入保护动作',
                                            trigger: 'blur'
                                        }
                                    ]"
                                >
                                    <el-input
                                        v-model="scope.row.protect"
                                        maxlength="20"
                                    ></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="修改">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <el-button
                                        @click="deleteProtect(scope.row)"
                                        type="danger"
                                    >删除
                                    </el-button
                                    >
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <!-- 电001  水002  温湿度003 漏电004 以及新增的其他类型 -->
                <template v-else>
                    <div style="text-align: right; margin-bottom: 20px">
                        <el-form class="leader-style-form" :inline="true">
                            <el-form-item
                                label="数据项名称"
                                label-width="100"
                                v-if="
                                    addComForm.point_class_id != '099' &&
                                        addComForm.point_class_id != ''
                                "
                            >
                                <el-select
                                    v-model="pointClassMainId"
                                    @change="changeClassMainId"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in classSelects"
                                        :key="item.pointClassMainId"
                                        :label="item.mainName"
                                        :value="item.pointClassMainId"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button
                                    class="leader-common-button"
                                    @click="addListEmpty()"
                                >增加
                                </el-button
                                >
                            </el-form-item>
                        </el-form>
                    </div>

                    <el-scrollbar style="height: 60%">
                        <el-table
                            border
                            style="width: 100%"
                            :data="addComForm.pointDesignInfos"
                            class="leader-style-table"
                        >
                            <el-table-column
                                label="数据项"
                                property="column_name"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'pointDesignInfos.' +
                                                scope.$index +
                                                `.column_name`
                                        "
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请输入数据项',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input
                                            @blur="columnNameInput"
                                            v-model.trim="scope.row.column_name"
                                            maxlength="60"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="分类"
                                property="point_class_column_kind_id"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'pointDesignInfos.' +
                                                scope.$index +
                                                `.point_class_column_kind_id`
                                        "
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请选择分类',
                                                trigger: 'change'
                                            }
                                        ]"
                                    >
                                        <el-select
                                            v-model="
                                                scope.row
                                                    .point_class_column_kind_id
                                            "
                                        >
                                            <el-option
                                                v-for="item in kinds"
                                                :key="
                                                    item.point_class_column_kind_id
                                                "
                                                :label="item.kind_name"
                                                :value="
                                                    item.point_class_column_kind_id
                                                "
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="二次变比"
                                property="column_rate"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'pointDesignInfos.' +
                                                scope.$index +
                                                `.column_rate`
                                        "
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请输入排序',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <!-- /^\d*(\.?\d{0,2})/g -->
                                        <el-input
                                            v-model="scope.row.column_rate"
                                            v-Int.float
                                            maxlength="10"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="排序" property="seq_num">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'pointDesignInfos.' +
                                                scope.$index +
                                                `.seq_num`
                                        "
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请输入排序',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input
                                            v-model="scope.row.seq_num"
                                            maxlength="3"
                                            v-Int
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="中文名称"
                                property="column_desc"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'pointDesignInfos.' +
                                                scope.$index +
                                                `.column_desc`
                                        "
                                        :rules="[
                                            {
                                                required: false,
                                                message: '请输入中文名称',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input
                                            v-model="scope.row.column_desc"
                                            maxlength="20"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="单位"
                                property="column_unit"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'pointDesignInfos.' +
                                                scope.$index +
                                                `.column_unit`
                                        "
                                    >
                                        <el-input
                                            v-model="scope.row.column_unit"
                                            maxlength="20"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="颜色"
                                property="column_color"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'pointDesignInfos.' +
                                                scope.$index +
                                                `.column_color`
                                        "
                                    >
                                        <el-input
                                            v-model="scope.row.column_color"
                                            maxlength="20"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="修改">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-button
                                            @click="deleteItem(scope.row)"
                                            type="danger"
                                        >删除
                                        </el-button
                                        >
                                    </el-form-item>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-scrollbar>
                </template>
            </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer"> 
            <el-button
                v-loading="saveLoading"
                :disabled="saveLoading"
                class="leader-common-button"
                @click="submitCollectionPoint"
            >保 存
            </el-button
            >
            <el-button @click="cancelDialog" class="leader-common-button"
            >取 消
            </el-button
            >
        </div>

        <el-dialog
            title="切换父采集点"
            width="1000px"
            @close="closeDialogPPoint"
            :visible.sync="pointDialogVisible"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            class="leader-dialog"
        >
            <div style="width: 100%; height: 470px">
                <el-scrollbar style="height: 90%">
                    <me-tree
                        style="width: 100%; border-right: 0;padding: 0 40px"
                        ref="myTree"
                        :treeData="treeList"
                        :treeLoading="treeLoading"
                        :treeToolBar="false"
                        :defaultProps="defaultPropsPoint"
                        :defaultCheckKeys="defaultCheckKeys"
                        :defaultExpandedKeys="defaultExpandedKeys"
                        :nodeKey="'point_id'"
                        @handleTreeNodeClick="handleNodePPointClick"
                    ></me-tree>
                </el-scrollbar>
                <div
                    slot="footer"
                    class="dialog-footer"
                    style="text-align: center"
                >
                    <!-- <el-button
                        @click="pointDialogVisible = false"
                        class="leader-common-button"
                        >取消</el-button
                    >-->
                    <el-button
                        class="leader-common-button"
                        @click="pointChangeCommit"
                    >确定
                    </el-button
                    >
                </div>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
    import * as api from "@/http/collection-point-design.js";
    import {
        getCodelistByKind,
        getPointList,
        getPointClassColumnKindList,
        getPointClassMainSelect,
        getPointClassMainDetail,
        getPointsList
    } from "@/http/api.js";
    import Tree from "@/comon/components/tree.vue";
    import { getBWGPointList, getFPointList } from "@/http/collection-point-design.js";

    export default {
        components: {
            "me-tree": Tree
        },
        props: {
            dialogFormVisible: {
                type: Boolean,
                default: false
            },
            dialogType: {
                type: String,
                default: "add"
            },
            treeId: {
                type: String
            },
            treePId: {
                type: String
            },
            parentPointClassId: {
                type: String
            }
        },
        watch: {
            dialogFormVisible(newVal) {
                if (newVal === true) {
                    this.getDocId(this.treeId);
                    this.getFrequencyList();
                    this.getPointType();
                    this.getPointClassList();
               
                    if (this.dialogType !== "add") {
                        // 修改
                        this.getFPointList(this.treeId);
                        this.getAccountList(this.treeId);
                        this.getInfoById(this.treeId);
                        this.getPointsList();
                        if (
                            this.parentPointClassId != null &&
                            this.parentPointClassId != "" &&
                            this.parentPointClassId != undefined
                        ) {
                            this.getPointClassColumnKindList(
                                this.parentPointClassId
                            );
                        }
                    } else {
                        // 新增
                        this.getFPointList();
                        this.addComForm.pointDesignInfos = [];
                        this.getAccountList(this.treeId, true);
                        this.getPointsList();
                        api.getInfoById({
                            point_id: this.treeId
                        }).then(res => {
                            if (res && res.error_code === "0") {

                                this.addComForm.p_point_name =
                                    res.bus_json.point_name;
                                this.addComForm.p_point_id = res.bus_json.point_id;
                                this.addComForm.elec_customer_id = res.bus_json.elec_customer_id;
                                this.addComForm.switchList = [
                                    {
                                        column_name: "",
                                        switch1_name: "",
                                        switch0_name: ""
                                    }
                                ];
                            }
                            this.getBWGPointList(this.addComForm.point_class_id);
                        });
                        this.$nextTick(() => {
                            this.$refs["addComForm"].clearValidate();
                            // this.addComForm.point_class_id = this.parentPointClassId;
                            // this.getPointClassColumnKindList(
                            //     this.addComForm.point_class_id
                            // );
                        });
                    }
                }
            }
        },
        data() {
            return {
                addComForm: {
                    p_point_id: "",
                    p_point_name: "",
                    point_name: "",
                    position: "",
                    // doc_id: "",
                    elec_customer_account_id: "",
                    collect_frequency: "",
                    point_class_id: "",
                    point_type: "",
                    pv_type: "", // 光伏类型
                    // jc_rate: "",
                    pointDesignInfos: [],
                    switchList: [],
                    tempData: [],
                    factory_no: "",
                    protectList: [],
                    f_to_point_id: "",
                    rated_p: "",
                    bwg_point_id: "",
                    model: "",
                    capacity: "",
                    relation_point_id: ""
                },
                addComRules: {
                    p_point_name: [
                        {
                            required: true,
                            message: "请选择父采集点",
                            trigger: "change"
                        }
                    ],
                    point_name: [
                        {
                            required: true,
                            message: "请填写采集点名称",
                            trigger: "blur"
                        }
                    ],
                    position: [
                        {
                            required: true,
                            message: "请填写安装位置名称",
                            trigger: "blur"
                        }
                    ],

                    elec_customer_account_id: [
                        {
                            required: true,
                            message: "请选择户号",
                            trigger: "change"
                        }
                    ],
                    collect_frequency: [
                        {
                            required: true,
                            message: "请选择采集频率",
                            trigger: "change"
                        }
                    ],
                    point_class_id: [
                        {
                            required: true,
                            message: "请选择采集点类型",
                            trigger: "change"
                        }
                    ],
                    pv_type: [
                        {
                            required: true,
                            message: "请选择光伏类型",
                            trigger: "blur"
                        }
                    ],
                    rated_p: [
                        {
                            min: 0,
                            max: 50,
                            message: "交流功率长度不可以超过50",
                            trigger: "blur"
                        }
                    ],
                    model: [
                        {
                            min: 0,
                            max: 50,
                            message: "型号长度不可以超过50",
                            trigger: "blur"
                        }
                    ]
                },
                unitList: [],
                numberList: [],
                frequencyList: [],
                saveLoading: false,
                point_type_list: [],
                point_types: [],
                point_f: [],
                point_bwg: [],
                pv_types: [], //光伏类型
                pointDialogVisible: false,
                treeList: [],
                defaultPropsPoint: {
                    children: "childList",
                    label: "point_name"
                },
                defaultCheckKeys: [],
                defaultExpandedKeys: [], //默认展开的层数
                kinds: [],
                del_pIDs: [],
                classSelects: [],
                pointList1111: [],
                pointClassMainId: ""
            };
        },
        methods: {
            // 获得反向采集点列表
            getFPointList(selectId) {
                api.getFPointList({ point_id: selectId }).then(res => {
                    if (res && res.error_code === "0") {
                        //this.point_type_list = res.bus_json;
                        this.point_f = res.bus_json;
                        //console.log('#' + JSON.stringify(res.bus_json));
                    }
                });
            },
            // 获得并网柜采集点列表
            getBWGPointList(point_class_id) {
                if (point_class_id == "1689906136465186816") {
                    point_class_id = "1658026900632879104";
                } else if (point_class_id == "021") {
                    point_class_id = "020";
                } else if (point_class_id == "022") {
                    point_class_id = "021";
                } else if (point_class_id == "023") {
                    point_class_id = "022";
                }
                api.getBWGPointList({ point_class_id: point_class_id }).then(res => {
                    if (res && res.error_code === "0") {
                        //this.point_type_list = res.bus_json;
                        this.point_bwg = res.bus_json;
                        //console.log('#' + JSON.stringify(res.bus_json));
                    }
                });
            },
            // 采集点类型
            getPointClassList() {
                api.getPointClassList().then(res => {
                    if (res && res.error_code === "0") {
                        this.point_type_list = res.bus_json;
                    }
                });
            },
            // 关联的电表id
            getPointsList() {
                this.pointList1111 = [];
                getPointsList().then(res => {
                    if (res && res.error_code === "0") {
                        console.log(res.bus_json);
                        this.pointList1111 = res.bus_json;
                    }
                });
            },
            // 获得反向采集点列表
            getFPointList(selectId) {
                api.getFPointList({ point_id: selectId }).then(res => {
                    if (res && res.error_code === "0") {
                        //this.point_type_list = res.bus_json;
                        this.point_f = res.bus_json;
                        //console.log('#' + JSON.stringify(res.bus_json));
                    }
                });
            },
            /**
             * 获取节点信息
             * params {selectId<String>}  选中树节点ID
             */
            getInfoById(selectId) {
                api.getInfoById({
                    point_id: selectId
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.addComForm.point_name = res.bus_json.point_name;
                        this.addComForm.position = res.bus_json.position;
                        this.addComForm.p_point_name = res.bus_json.p_point_name;
                        this.addComForm.p_point_id = res.bus_json.p_point_id;
                        // this.addComForm.doc_id = res.bus_json.doc_id;
                        this.addComForm.factory_no = res.bus_json.factory_no;
                        this.addComForm.elec_customer_account_id =
                            res.bus_json.elec_customer_account_id;
                        this.addComForm.collect_frequency =
                            res.bus_json.collect_frequency;
                        this.addComForm.point_class_id =
                            res.bus_json.point_class_id;
                        this.addComForm.point_type = res.bus_json.point_type;
                        this.addComForm.pv_type = res.bus_json.pv_type;
                        // this.addComForm.jc_rate = res.bus_json.jc_rate;
                        this.addComForm.pointDesignInfos =
                            res.bus_json.pointDesignInfos;
                        this.addComForm.protectList = res.bus_json.protectList;
                        this.addComForm.switchList = res.bus_json.switchList;
                        this.addComForm.f_to_point_id = res.bus_json.f_to_point_id;
                        this.addComForm.bwg_point_id = res.bus_json.bwg_point_id;
                        this.addComForm.rated_p = res.bus_json.rated_p;
                        this.addComForm.model = res.bus_json.model;
                        this.addComForm.capacity = res.bus_json.capacity;
                        this.addComForm.relation_point_id = res.bus_json.relation_point_id;
                        if (
                            this.addComForm.point_class_id != null &&
                            this.addComForm.point_class_id != undefined &&
                            this.addComForm.point_class_id != ""
                        ) {
                            this.getPointClassColumnKindList(
                                this.addComForm.point_class_id
                            );
                            this.getPointClassMainSelect(
                                this.addComForm.point_class_id
                            );
                        }
                    }
                    this.getBWGPointList(this.addComForm.point_class_id);
                });
            },
            /**
             * 提交新增采集点信息
             */
            submitCollectionPoint() {
                this.$refs["addComForm"].validate(valid => {
                    if (valid) {
                        this.saveLoading = true;
                        let params = {};
                        if (this.dialogType === "add") {
                            this.addComForm.factory_no = "";
                            params = {
                                ...this.addComForm
                            };
                        } else {
                            params = {
                                ...this.addComForm,
                                point_id: this.treeId
                            };
                        }
                        api.savePointDesign(params).then(res => {
                            if (res && res.error_code == "0") {
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                this.$emit("collectionPointAddCb");
                                this.dialogFormVisible = false;
                            } else {
                                // this.dialogFormVisible = false;
                            }
                            this.saveLoading = false;
                        });
                    }
                });
            },
            /**
             * 获得采集单元下拉
             */
            getDocId(selectId) {
                api.getDocId({
                    point_id: selectId
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.unitList = res.bus_json;
                    }
                });
            },
            /**
             * 获得户号下拉
             *params {selectId<String>} tree id
             *params {loadingStatus<Boolean>} 是否关闭loading状态
             */
            getAccountList(selectId, loadingStatus) {
                api.getAccountList({
                    point_id: selectId
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.numberList = res.bus_json;
                    }
                });
            },
            /**
             * 获取频率下拉
             */
            getFrequencyList() {
                getCodelistByKind({
                    code_kind: "collect_frequency"
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.frequencyList = res.bus_json[0].codelists;
                    }
                });
            },
            /**
             * 获取用途下拉
             */
            getPointType() {
                getCodelistByKind({
                    code_kind: "point_type;pv_type"
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.point_types = res.bus_json[0].codelists;
                        this.pv_types = res.bus_json[1].codelists;
                    }
                });
            },
            /**
             * @description: 切换采集点类型
             */
            changeClassId(item) {
                this.addComForm.point_class_id = item;
                this.pointClassMainId = "";
                // 切换的时候  数据项名称跟着切换
                this.getPointClassMainSelect(this.addComForm.point_class_id);
                // 表格中的分类
                this.getPointClassColumnKindList(this.addComForm.point_class_id);
                this.addComForm.pointDesignInfos = [];

                // 开关099 红外095 门磁096 水侵097 烟感098
                if (
                    item == "099" ||
                    item == "095" ||
                    item == "096" ||
                    item == "097" ||
                    item == "098"
                ) {
                    // if (this.addComForm.switchList == null || this.addComForm.switchList.length == 0) {
                    this.addComForm.switchList = [
                        {
                            column_name: "",
                            switch1_name: "",
                            switch0_name: ""
                        }
                    ];
                    // }
                }

                if (item != "020") {
                    this.addComForm.relation_point_id = "";
                }else {
                    this.addComForm.bwg_point_id = "";
                }
                // 获得采集点列表
                this.getBWGPointList(this.addComForm.point_class_id);

            },
            // 驼峰转下划线
            // 对象驼峰转下划线
            objectHumpToLine(obj) {
                var newObj = new Object();
                for (let key in obj) {
                    newObj[key.replace(/([A-Z])/g, "_$1").toLowerCase()] = obj[key];
                }
                return newObj;
            },
            // 获取数据项名称具体数据
            changeClassMainId(val) {
                this.getPointClassMainDetailData(val);
            },
            getPointClassMainDetailData(pointClassMainId) {
                getPointClassMainDetail({ pointClassMainId }).then(res => {
                    if (res && res.error_code === "0") {
                        this.addComForm.pointDesignInfos = [];
                        let arr = res.bus_json.column;
                        arr.forEach(item => {
                            const s = this.objectHumpToLine(item);
                            this.addComForm.pointDesignInfos.push(s);
                        });
                    }
                });
            },
            // 获取数据项名称
            getPointClassMainSelect(pointClass_id) {
                getPointClassMainSelect({ pointClassId: pointClass_id }).then(
                    res => {
                        if (res && res.error_code === "0") {
                            this.classSelects = res.bus_json;
                        }
                    }
                );
            },
            // 获取分类的接口
            getPointClassColumnKindList(point_class_id) {
                getPointClassColumnKindList({ point_class_id }).then(res => {
                    if (res && res.error_code === "0") {
                        this.kinds = res.bus_json;
                    }
                });
            },
            // 验证数据项输入的时候，不能重复
            columnNameInput(event) {
                let a = {};
                this.addComForm.pointDesignInfos.forEach(item => {
                    if (item.column_name == event.target.value) {
                        if (a[event.target.value]) {
                            this.$message.error("数据项名称不能重复");
                            event.target.value = "";
                            return;
                        } else {
                            a[event.target.value] = 1;
                        }
                    }
                });
            },
            // 添加保护动作
            addProtect() {
                const newOne = {
                    column_name: "",
                    protect: ""
                };
                if (this.addComForm.protectList == null) {
                    this.addComForm.protectList = [];
                }
                this.addComForm.protectList.push(newOne);
            },
            // 删除保护动作
            deleteProtect(sth) {
                this.$confirm("确认删除这条数据吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(_ => {
                    this.addComForm.protectList.forEach(function(item, index, arr) {
                        if (item == sth) {
                            arr.splice(index, 1);
                        }
                    });
                });
            },
            // 添加电流
            addListEmpty() {
                const newOne = {
                    column_name: "",
                    point_class_column_kind_id: "",
                    seq_num: "",
                    column_desc: "",
                    column_unit: "",
                    column_rate: "1",
                    column_color: ""
                };
                if (this.addComForm.pointDesignInfos == null) {
                    this.addComForm.pointDesignInfos = [];
                }
                this.addComForm.pointDesignInfos.push(newOne);
            },
            deleteItem(sth) {
                this.$confirm("确认删除这条数据吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(_ => {
                    this.addComForm.pointDesignInfos.forEach(function(
                        item,
                        index,
                        arr
                    ) {
                        if (item == sth) {
                            arr.splice(index, 1);
                        }
                    });
                    if (sth.point_column_id)
                        this.del_pIDs.push(sth.point_column_id);
                });
            },
            // 切换父采集点
            changePPointID() {
                if (
                    this.addComForm.p_point_id == null ||
                    this.addComForm.p_point_id == ""
                ) {
                    this.$confirm("根节点没有父采集点?", "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                    }).then(() => {
                    });
                    // 移除焦点
                    this.$refs.p_point_ref.blur();
                } else {
                    this.pointDialogVisible = true;

                    this.getPointList();
                }
            },
            /**
             * 获得采集点树列表
             */
            getPointList() {
                getPointList().then(res => {
                    if (res && res.error_code === "0") {
                        this.treeList = res.bus_json;
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addComForm.p_point_id
                            );
                        });
                    }
                });
            },
            handleNodePPointClick(point) {
                this.addComForm.p_point_id = point.point_id;
                this.addComForm.p_point_name = point.point_name;
            },
            pointChangeCommit() {
                if (
                    this.addComForm.p_point_id == null ||
                    this.addComForm.p_point_id == ""
                ) {
                    this.$message({
                        message: "请选择采集点",
                        type: "warning"
                    });
                } else {
                    this.closeDialogPPoint();
                }
            },
            closeDialogPPoint() {
                this.pointDialogVisible = false;
            },
            cancelDialog() {
                this.del_pIDs = [];
                this.pointClassMainId = "";
                this.dialogFormVisible = false;
            },
            /**
             * 关闭弹窗回调函数
             */
            closeAddDialog() {
                this.$refs["addComForm"].resetFields();
                this.$refs["addComForm"].clearValidate();
                this.$emit("update:dialogFormVisible", this.dialogFormVisible);
            }
        }
    };
</script>
<style lang="scss" scoped>
    .leader-style-form .el-form-item {
        margin-right: 0px !important;
    }

    .tip_col {
        text-align: right;
        color: #fa3a3a;
        line-height: 2.083rem;
    }

    .line_height input {
        line-height: 1;
    }
</style>
